<script setup lang="ts">
import { computed } from 'vue'
import { useRateStore } from '@/store/rate'
import { useI18n } from '@/composable/useI18n'

const { t } = useI18n()

const rateStore = useRateStore()

const rateData = computed(() => rateStore.getRateData)

const totals = computed(() => {
  if (!rateData.value?.energy_sensors_totalizers) {
    return { offPeakConsumption: 0, peakConsumption: 0, offPeakDemand: 0, peakDemand: 0 }
  }

  return rateData.value.energy_sensors_totalizers.reduce(
    (acc, sensor) => {
      acc.offPeakConsumption += Math.round(sensor.totalizer.consumption.off_peak_consumption_kwh) || 0
      acc.peakConsumption += Math.round(sensor.totalizer.consumption.peak_consumption_kwh) || 0
      acc.offPeakDemand += Math.round(sensor.totalizer.demand.off_peak_demand_kw) || 0
      acc.peakDemand += Math.round(sensor.totalizer.demand.peak_demand_kw) || 0
      return acc
    },
    { offPeakConsumption: 0, peakConsumption: 0, offPeakDemand: 0, peakDemand: 0 },
  )
})
</script>

<template>
  <div class="flex flex-col gap-4 bg-white p-4 shadow-md">
    <h1 class="font-semibold text-black">{{ t('rate.consumption_and_demand_table.title') }}</h1>
    <table class="w-full">
      <thead>
        <tr class="bg-slate-200">
          <th class="p-2 text-left"></th>
          <th class="p-2 text-left">{{ t('rate.consumption_and_demand_table.consumption_off_peak_consumption_kwh') }}</th>
          <th class="p-2 text-left">{{ t('rate.consumption_and_demand_table.consumption_peak_consumption_kwh') }}</th>
          <th class="p-2 text-left">{{ t('rate.consumption_and_demand_table.demand_off_peak_demand_kw') }}</th>
          <th class="p-2 text-left">{{ t('rate.consumption_and_demand_table.demand_peak_demand_kw') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(energySensor, index) in rateData?.energy_sensors_totalizers" :key="index">
          <td class="p-2 font-semibold text-black">{{ energySensor.sensor_name }}</td>
          <td class="p-2 font-medium text-black">{{ Math.round(energySensor.totalizer.consumption.off_peak_consumption_kwh) }}</td>
          <td class="p-2 font-medium text-black">{{ Math.round(energySensor.totalizer.consumption.peak_consumption_kwh) }}</td>
          <td class="p-2 font-medium text-black">{{ Math.round(energySensor.totalizer.demand.off_peak_demand_kw) }}</td>
          <td class="p-2 font-medium text-black">{{ Math.round(energySensor.totalizer.demand.peak_demand_kw) }}</td>
        </tr>
        <tr>
          <td class="p-2 font-semibold text-black">Total</td>
          <td class="p-2">{{ totals.offPeakConsumption }}</td>
          <td class="p-2">{{ totals.peakConsumption }}</td>
          <td class="p-2">{{ totals.offPeakDemand }}</td>
          <td class="p-2">{{ totals.peakDemand }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
